import { render, staticRenderFns } from "./OrganizationalChart.vue?vue&type=template&id=4a21621a&scoped=true&"
import script from "./OrganizationalChart.vue?vue&type=script&lang=js&"
export * from "./OrganizationalChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a21621a",
  null
  
)

export default component.exports